var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("COPYRIGHT © ")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_c('span',[_vm._v("AMANAH KARYA DIGITAL")])])])}
var staticRenderFns = []

export { render, staticRenderFns }